import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, shareReplay, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';

export type MenuResponse = Record<string, string[]>;

@Injectable({ providedIn: 'root' })
export class MenuService {
  private readonly API = `${environment.baseUrl}/menu`;
  private readonly reload$ = new BehaviorSubject<void>(undefined);

  readonly menu$: Observable<MenuResponse> = this.reload$.pipe(
    switchMap(() => this.http.get<MenuResponse>(this.API)),
    map((res) => res ?? {}),
    shareReplay({ bufferSize: 1, refCount: false }),
  );

  constructor(private http: HttpClient) {}

  reload(): void {
    this.reload$.next();
  }
}
